import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form--destroy-handler"
export default class extends Controller {
  static targets = ["destroy", "container"]

  connect() {
    this.#hideRemovedItems()
  }

  remove(_event) {
    this.destroyTarget.value = true
    // we cant remove it we need to only set _destroy hidden attribute
    // due to rails to know which document items destroy on update or delete
    this.containerTarget.classList.add("d-none")
  }

  #hideRemovedItems() {
    if (this.destroyTarget.value === "true") {
      this.containerTarget.classList.add("d-none")
    }
  }
}
